const en = {
  tools_actions: {
    hotel_info: "Looking for hotel information...",
    accommodation_info: "Looking for hotel information...",
    accomodation_info: "Looking for hotel information...",
    get_destination_info: "Looking for things to do nearby...",
    get_guest_information: "Checking your reservation...",
    book_hotel_service_or_get_availability: "Checking the service availability...",
    list_accomodations: "Loading the accommodations...",
    set_accomodation: "Loading the accommodation...",
    list_accommodations: "Loading the accommodations...",
    set_accommodation: "Loading the accommodation...",
    destination_info: "Looking for things to do nearby...",
    show_map: "Preparing the map...",
    consult_rules: "Checking the property's rules...",
    notify_reception: "Notifying the reception...",
    save_self_declared_stay: "Saving your stay...",
    generate_quote_for_single_room_longstay_rooms: "Preparing a quote...",
    generate_quote_for_multiple_rooms_longstay: "Preparing a quote...",
    hotel_info_iodah:
      "Perfect, I'm collecting the info, will be right with you...",
    generate_quote_for_rooms: "Preparing a quote...",
    check_availability: "Checking availability...",
    print_calendar: "Checking calendar...",
    nearby_restaurants: "Looking for nearby restaurants...",
    nearby_attractions: "Looking for nearby attractions...",
    human_handoff: "Handing off to an operator...",
    tool_search_offers_by_request: "Searching the best offers for you...",
    tool_search_hotels_by_request: "Searching the best hotels for you...",
  },
  tool_status_sequences: {
    generate_quote_for_rooms: [
      "Checking availability for your dates…",
      "Comparing rooms and rates…",
      "Preparing your quote…",
    ],
    generate_quote_for_single_room_longstay_rooms: [
      "Checking availability for your dates…",
      "Comparing rooms and rates…",
      "Preparing your quote…",
    ],
    generate_quote_for_multiple_rooms_longstay: [
      "Checking availability for your dates…",
      "Comparing rooms and rates…",
      "Preparing your quote…",
    ],
    check_availability: [
      "Checking the calendar…",
      "Verifying availability…",
      "One more moment…",
    ],
    hotel_info: [
      "Looking through the hotel info…",
      "Gathering the details…",
      "Preparing the answer…",
    ],
    accommodation_info: [
      "Looking through the hotel info…",
      "Gathering the details…",
      "Preparing the answer…",
    ],
    accomodation_info: [
      "Looking through the hotel info…",
      "Gathering the details…",
      "Preparing the answer…",
    ],
    get_destination_info: [
      "Exploring the surroundings…",
      "Picking the best suggestions…",
      "Almost ready…",
    ],
    nearby_restaurants: [
      "Looking for restaurants nearby…",
      "Selecting the most suitable ones…",
      "Almost ready…",
    ],
    nearby_attractions: [
      "Looking for things to do nearby…",
      "Selecting the best…",
      "Almost ready…",
    ],
    get_guest_information: [
      "Retrieving your reservation…",
      "Checking your stay details…",
      "One more moment…",
    ],
    book_hotel_service_or_get_availability: [
      "Checking the service availability…",
      "Verifying the schedule…",
      "One more moment…",
    ],
    print_calendar: ["Opening the calendar…", "Checking the dates…"],
    list_accomodations: ["Loading the accommodations…", "Preparing the list…"],
    set_accomodation: ["Opening the accommodation…", "Retrieving the information…"],
    list_accommodations: ["Loading the accommodations…", "Preparing the list…"],
    set_accommodation: ["Opening the accommodation…", "Retrieving the information…"],
    destination_info: [
      "Exploring the surroundings…",
      "Picking the best suggestions…",
      "Almost ready…",
    ],
    show_map: ["Locating the places on the map…", "Preparing the itinerary…"],
    consult_rules: ["Checking the property's rules…", "Verifying the conditions…"],
    notify_reception: ["Notifying the reception…", "Forwarding your request…"],
    save_self_declared_stay: ["Saving your stay…", "Linking your booking…"],
    human_handoff: ["Notifying the reception…", "Handing over the conversation…"],
    tool_search_offers_by_request: [
      "Searching the best offers for you…",
      "Comparing the options…",
      "Almost ready…",
    ],
    tool_search_hotels_by_request: [
      "Searching the most suitable hotels…",
      "Comparing the options…",
      "Almost ready…",
    ],
  },
  status_thinking: ["Just a moment…", "Thinking it through…", "One more moment…"],
  status_generic: ["Almost there…", "One more moment…"],
  tooltip_sentences: [
    "Need a quick quote? 😊",
    "Need information about the hotel? 😊",
  ],
  // Variant B of the open-rate experiment: two clickable teaser pills ·
  // a fixed high-intent hook on top, a rotating multi-intent pill below.
  // A click opens the chat and sends the pill as the guest message.
  // Hotels can override these from the backoffice (per locale); these are
  // the defaults when no configuration is present.
  welcome_message_default:
    "Hi! 👋 I'm the hotel's virtual assistant. I can check availability and rates and answer any question about your stay. How can I help?",
  teaser_pill_fixed: "Quote in 30 seconds ⚡",
  teaser_pills_rotating: [
    "Any rooms free for your dates? 📅",
    "Which rooms do you have? 🛏️",
    "What's breakfast like? 🥐",
  ],
  quote_pills: {
    alone: "Just me",
    alone_message: "Just me, one person",
    party: "We are {n}",
    party_message: "We are {n} people",
  },
  replies_in_realtime: "Replies in real-time",
  ai_disclosure: "I'm the property's AI assistant. You can ask for a member of staff whenever you like.",
  powered_by: "Powered by",
  type_a_message: "Type a message...",
  speak_with_operator: "Speak with an operator",
  // "Call us" card in the welcome message (VoiceCallCard).
  voice_call: {
    title: "Call us",
    subtitle: "Our voice assistant answers right away",
    badge: "New",
    call: "Call",
    copy: "Copy number",
    copied: "Number copied",
  },
  continue_on_whatsapp: "Continue on WhatsApp",
  whatsapp_handoff_prefill:
    "Hi! I was chatting with the assistant on your website and I'd like to continue here.",
  request_quote: "Request a quote",
  map_directions: "Open in Maps",
  handoff_form: {
    title: "Contact us",
    desc: "Leave your details and our team will get back to you as soon as possible.",
    firstname: "First Name",
    lastname: "Last Name",
    email: "Email",
    phone: "Phone",
    phone_hint: "We'll use this to reach you, including on WhatsApp.",
    phone_search: "Search country",
    submit: "Submit Request",
    success:
      "Thanks! We've received your details and will get back to you as soon as possible. 😊",
    handoff_email_success:
      "We'll reply by email at {email}. You can close this page.",
    submit_error: "Something went wrong. Please try again shortly.",
    firstname_error: "Please enter your first name.",
    lastname_error: "Please enter your last name.",
    email_error: "Please enter a valid email address.",
    phone_error: "Please enter a valid phone number.",
  },
  delete_chat_aria_label: "Delete Chat",
  close_aria_label: "Close Chat",
  send_aria_label: "Send Message",
  open_content: "Open Content",
  book_now: "Book Now",
  // Inline link chips in a message (CustomLinkRenderer): shown next to the
  // address/number the assistant wrote, and used as the accessible label.
  send_email: "Send an email",
  call_now: "Call",
  whatsapp_chat: "Chat on WhatsApp",
  open_link: "Open link",
  discover_hotel: "Discover the hotel",
  discover_offer: "Discover the offer",
  quick_quote: "Request a quick quote",
  view_hotel_photos: "View hotel photos",
  view_photos: "View photos",
  hotel_gallery: "Hotel",
  restaurant_gallery: "Restaurant",
  animation_gallery: "Animation",
  rooms_gallery: "Rooms",
  look_hotel_galleries: "View hotel galleries:",
  back_to_chat: "Back to chat",
  carousel_open: "Open",
  carousel_close: "Close",
  available: "Available",
  expand_view: "Full view",
  read_more: "Read more",
  explore: "Explore",
  photo: "Photo",
  from_price: "from",
  rates: "Rates",
  quote_group: {
    title: "Your quote",
    total: "Total",
    room: "Room {n}",
    other_options: "Other options",
    rooms: "{n} rooms",
    adult: "adult",
    adults: "adults",
    child: "child",
    children: "children",
  },
  anchor_rooms: "Our proposals",
  anchor_discover: "To discover",
  anchor_places: "Location & surroundings",
  anchor_videos: "Videos",
  videos: "videos",
  watch_video: "Watch the video",
  feedback_useful: "Helpful reply",
  feedback_not_useful: "Not helpful",
  proposal: "proposal",
  proposals: "proposals",
  contents: "contents",
  places: "places",
  explore_title: "Your stay",
  explore_rooms: "Rooms & rates",
  explore_discover: "To discover",
  explore_videos: "Videos",
  explore_places: "Places",
  directions: "Directions",
  minimize_view: "Minimize",

  // 1x6 P2-d-M · interactive concierge map (poi_map / itinerary templates).
  anchor_itinerary: "Your itinerary",
  itinerary: "Itinerary",
  stops: "stops",
  stop: "stop",
  walk_min: "min walk",
  itinerary_start: "Starting point",
  your_hotel: "Your hotel",
  explore_itineraries: "Itineraries",
  map_loading: "Loading map…",
  cat_restaurant: "Food & drink",
  cat_attraction: "Attractions",
  cat_beach: "Beaches",
  cat_essential: "Essentials",
  cat_event: "Events",
  cat_place: "Place",
  reviews: "reviews",

  booking: {
    choose_rate: "Choose your rate",
    your_details: "Your details",
    review: "Review",
    notes: "Notes or requests",
    notes_placeholder: "Allergies, arrival time, cot…",
    privacy: "I have read and accept the privacy policy.",
    marketing: "I'd like to receive offers and news from the hotel.",
    privacy_required: "Privacy consent is required to continue.",
    continue: "Continue",
    back: "Back",
    confirm: "Confirm booking",
    submitting: "One moment…",
    cancel: "Cancel",
    close: "Close",
    retry: "Try again",
    total: "Total",
    cheapest: "Best price",
    per_night: "per night",
    no_payment_now: "No payment now",
    nights: "nights",
    guests: "guests",
    reference: "Reference",
    success_title: "Booking confirmed",
    success_body: "You'll receive your confirmation by email shortly.",
    error_title: "That didn't go through",
    error_body: "We couldn't complete the booking. Please try again shortly.",
    mock_notice: "Test mode: no real booking was created.",
  },
};

export default en;
